export default "__VITE_ASSET__c425e48f__"